


































































import { defineComponent } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseTooltip from "@/components/BaseTooltip";
import GroupList from "@/components/GroupList";
import GroupSelectedInformer from "@/components/GroupSelectedInformer";

export default defineComponent({
  name: "GroupListSelection",
  components: { GroupSelectedInformer, BaseTooltip, BaseButton, BaseIcon, GroupList, BaseCheckbox },
  props: {
    loading: { type: Boolean, required: true },
    loadingCount: { type: Boolean, default: false },
    groups: { type: Array as () => Group[], required: true },
    selectedGroupIds: { type: Array as () => string[], required: true },
    excludeGroupIds: { type: Array as () => string[], required: true },
    recipientCount: { type: Number, default: 0 },
    btnIsBottom: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const onSelectGroup = (status: boolean, groupId: string) => {
      emit("selectGroup", { status, groupId });
    };
    const onExcludeGroup = (status: boolean, groupId: string) => {
      emit("excludeGroup", { status, groupId });
    };
    return {
      onSelectGroup,
      onExcludeGroup,
    };
  },
});
